import { USER_TP } from '../../../common/constants';

export const availCheck = (user_tp) => {
    let retVal = false;
    if(user_tp){
        switch(user_tp){
            case USER_TP.SUPER:
            case USER_TP.ADMIN:
            case USER_TP.MANAGE:
                retVal = true;
                break;
            case USER_TP.USER:
            case USER_TP.NORMAL:
            default:
                retVal=false;
                break;
        }
    }
    return retVal
}